import { EmbeddedMessage } from 'constants/messageMediums';
import { MessageMedium, SortDirection, Sorting } from 'modules/graphql';
import { Embedded24, SvgIconProps } from 'ui/icons';
import { KeyC, KeyJ, KeyS, KeyT, KeyU } from 'ui/icons/aurora/16px/cmdk';
import {
  SendEmail24,
  SendInApp24,
  SendPush24,
  SendSMS24,
  SendWebPush24,
} from 'ui/icons/aurora/24px/studio';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { CommandItem, MediumOptions, PAGE } from './types';

export const DEFAULT_SORT_BY = Sorting.UpdatedAt;

export const DEFAULT_SORT_DIRECTION = SortDirection.Descending;

export const DEFAULT_PAGINATION = {
  limit: 20,
  offset: 0,
};

export const MEDIUM_OPTIONS: MediumOptions = {
  email: {
    Icon: SendEmail24,
    id: 'email',
    label: 'Email',
    modalLabel: 'email',
    slug: MessageMedium.Email,
  },
  'in-app': {
    Icon: SendInApp24,
    id: 'in-app',
    label: 'In-App',
    modalLabel: 'in-app',
    slug: MessageMedium.InApp,
  },
  push: {
    Icon: SendPush24,
    id: 'push',
    label: 'Push',
    modalLabel: 'push',
    slug: MessageMedium.Push,
  },
  sms: {
    Icon: SendSMS24,
    id: 'sms',
    label: 'SMS',
    modalLabel: 'SMS',
    slug: MessageMedium.SMS,
  },
  'web-push': {
    Icon: SendWebPush24,
    id: 'web-push',
    label: 'Web Push',
    modalLabel: 'web push',
    slug: MessageMedium.WebPush,
  },
  embedded: {
    Icon: Embedded24,
    id: 'embedded',
    label: 'Embedded',
    modalLabel: 'embedded',
    slug: EmbeddedMessage,
  },
};

export const COMMAND_GROUP_ITEMS: CommandItem[] = [
  {
    name: 'New campaign',
    page: PAGE.CAMPAIGN_MEDIUMS,
    permissions: [PROJECT_PERMISSIONS.DraftMessaging],
  },
  {
    name: 'New journey',
    page: PAGE.JOURNEY_CREATION,
    permissions: [PROJECT_PERMISSIONS.DraftMessaging],
  },
  {
    name: 'New template',
    page: PAGE.TEMPLATE_MEDIUMS,
    permissions: [PROJECT_PERMISSIONS.ManageBaseTemplates],
  },
  {
    name: 'New snippet',
    url: '/templates/snippet/create',
    permissions: [PROJECT_PERMISSIONS.ManageSnippets],
  },
];

/** Properties associated with each search page */
export const SEARCH_PAGES: Record<
  | PAGE.USER_SEARCH
  | PAGE.CAMPAIGN_SEARCH
  | PAGE.JOURNEY_SEARCH
  | PAGE.TEMPLATE_SEARCH
  | PAGE.SNIPPET_SEARCH,
  {
    Icon: (props: SvgIconProps) => JSX.Element;
    key: string;
    page: PAGE;
    term: string;
    type: string;
  }
> = {
  [PAGE.USER_SEARCH]: {
    Icon: KeyU,
    key: 'U',
    page: PAGE.USER_SEARCH,
    term: 'user search',
    type: 'users',
  },
  [PAGE.CAMPAIGN_SEARCH]: {
    Icon: KeyC,
    key: 'C',
    page: PAGE.CAMPAIGN_SEARCH,
    term: 'campaign search',
    type: 'campaigns',
  },
  [PAGE.JOURNEY_SEARCH]: {
    Icon: KeyJ,
    key: 'J',
    page: PAGE.JOURNEY_SEARCH,
    term: 'journey search',
    type: 'journeys',
  },
  [PAGE.TEMPLATE_SEARCH]: {
    Icon: KeyT,
    key: 'T',
    page: PAGE.TEMPLATE_SEARCH,
    term: 'template search',
    type: 'templates',
  },
  [PAGE.SNIPPET_SEARCH]: {
    Icon: KeyS,
    key: 'S',
    page: PAGE.SNIPPET_SEARCH,
    term: 'snippet search',
    type: 'snippets',
  },
};
